import { useFormatCurrency, useGetPaymentStatusLabel } from "@/hooks";
import { useT } from "@/i18n";

import { TransactionSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type TransactionSearchItemViewProps = {
  item: TransactionSearchItem;
};

export const TransactionSearchItemView = ({ item }: TransactionSearchItemViewProps) => {
  const t = useT();
  const formatCurrency = useFormatCurrency();
  const getPaymentStatusLabel = useGetPaymentStatusLabel();

  const { transaction } = item;

  const amountLabel =
    transaction.amount != null && transaction.currency
      ? formatCurrency(transaction.amount, transaction.currency)
      : null;

  const statusLabel = transaction.paymentStatus
    ? getPaymentStatusLabel(transaction.paymentStatus)
    : null;

  // The search ref carries no payer or product name, so the row leads with the
  // most human-meaningful value it does have (the amount, else the processor's
  // reference) instead of the opaque `trx_…` id. A real fix needs a name field
  // on the backend's transaction search item.
  const label = amountLabel ?? transaction.paymentProcessorIntentId ?? transaction.id;

  const descriptionParts = [
    transaction.paymentProcessorIntentId === label ? null : transaction.paymentProcessorIntentId,
    statusLabel,
  ].filter(Boolean);

  const description = descriptionParts.length
    ? descriptionParts.join(" · ")
    : t("general.globalSearch.transaction.subtitle");

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{label}</SearchItemLabel>
          <SearchItemDescription>{description}</SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="transaction" />
      </div>
    </div>
  );
};
